import React, { Component } from 'react';
import { Modal, Col, Row } from 'antd';
import ReactToPrint from "react-to-print";
import { getUsuario } from "../utils/LoginManager";
import "../relatorios/Relatorios.css";
import moment from "moment-timezone"; // VALIDAR DATAS
import Colors from '../utils/Colors';

export default class PrintModalCupom extends Component {

    renderDataAtual = () => {
        return moment().format("DD/MM/YYYY HH:mm");
    }

    render() {
        const { children, ...outrasProps } = this.props;
        const usuario = getUsuario();

        return (
            <Modal {...outrasProps}
                footer={null}
                width={350}
                destroyOnClose
                style={{ top: 20 }}
            >
                <div>
                    <ReactToPrint
                        trigger={() => (
                            <a className="ant-btn ant-btn-primary">
                                Imprimir
                            </a>
                        )}
                        content={() => this.componentRef}
                        pageStyle={{ margin: -10, padding: 0 }}
                    />

                    <div style={{ height: 600, overflow: 'auto' }}>
                        <div ref={el => (this.componentRef = el)}>
                            <Row>{children}</Row>
                        </div>
                    </div>
                </div>
            </Modal >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/PrintModalCupom.js